import React from 'react';

const Truncated = ({ value, length = 10 }) => (
  <span>{value?.length > length ? `${value.slice(0, length)}...` : value}</span>
);

export default Truncated;
